/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ScriptSyncResultDto { 
    /**
     * Registry rows inserted for new script ids from S3
     */
    added: number;
    /**
     * Existing enabled registry rows soft-disabled because their script id was absent from the bucket listing
     */
    disabled: number;
    /**
     * Script directory names discovered under the bucket prefix
     */
    discovered: number;
    /**
     * Wall-clock time for the sync run in milliseconds
     */
    duration_ms: number;
    /**
     * Per-script error messages; sync continues for other scripts
     */
    errors: Array<string>;
    /**
     * Scripts skipped because S3 manifest Last-Modified matched stored source_modified_ts
     */
    skipped_unchanged: number;
    /**
     * Registry rows updated from a changed manifest
     */
    updated: number;
}

